import { useEffect, useState } from "react";
import HubUsageSelectionFilterDialog from "./HubUsageSelectionFilterDialog";

const types = [
    ["video", "Video"],
    ["audio", "Audio"],
    ["images", "Images"],
    ["pdf", "PDF"],
    ["presentations", "Presentations"],
    ["documents", "Documents"],
];

export default function HubUsageFileTypeFilterDialog(props) {
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        if (props.open) {
            setSelectedKeys(
                [
                    props.includeVideo && "video",
                    props.includeAudio && "audio",
                    props.includeImages && "images",
                    props.includePDFs && "pdf",
                    props.includePresentations && "presentations",
                    props.includeDocuments && "documents",
                ].filter(Boolean),
            );
        }
    }, [
        props.open,
        props.includeVideo,
        props.includeAudio,
        props.includeImages,
        props.includePDFs,
        props.includePresentations,
        props.includeDocuments,
    ]);

    function handleClose() {
        props.onClose(
            selectedKeys.includes("video"),
            selectedKeys.includes("audio"),
            selectedKeys.includes("images"),
            selectedKeys.includes("pdf"),
            selectedKeys.includes("presentations"),
            selectedKeys.includes("documents"),
        );
    }

    function handleToggle(key) {
        setSelectedKeys(
            selectedKeys.includes(key)
                ? selectedKeys.filter((selectedKey) => selectedKey !== key)
                : [...selectedKeys, key],
        );
    }

    return (
        <HubUsageSelectionFilterDialog
            open={props.open}
            onClose={handleClose}
            title="File type filter"
            items={types.map(([key, label]) => ({ key, label }))}
            selectedKeys={selectedKeys}
            onToggle={handleToggle}
            onToggleAll={() =>
                setSelectedKeys(
                    selectedKeys.length === types.length
                        ? []
                        : types.map(([key]) => key),
                )
            }
        />
    );
}
